/**
 * @class EventBus
 * @description Un système simple de Publish/Subscribe pour découpler les modules.
 */
class EventBus {
    constructor() {
        this.listeners = {};
    }

    /**
     * S'abonne à un événement
     * @param {string} event - Le nom de l'événement
     * @param {Function} callback - La fonction à appeler
     */
    on(event, callback) {
        if (!this.listeners[event]) {
            this.listeners[event] = [];
        }
        this.listeners[event].push(callback);
    }

    /**
     * Se désabonne d'un événement
     * @param {string} event - Le nom de l'événement
     * @param {Function} callback - La fonction à retirer
     */
    off(event, callback) {
        if (!this.listeners[event]) return;
        this.listeners[event] = this.listeners[event].filter(cb => cb !== callback);
    }

    /**
     * Émet un événement
     * @param {string} event - Le nom de l'événement
     * @param {any} data - Les données associées à l'événement
     */
    emit(event, data) {
        if (!this.listeners[event]) return;
        this.listeners[event].forEach(callback => callback(data));
    }
}

// Instance unique (Singleton)
export const eventBus = new EventBus();

/**
 * Liste des événements constants pour éviter les fautes de frappe
 */
export const EVENTS = {
    GAME_START: "GAME_START",
    GAME_PAUSE: "GAME_PAUSE",
    GAME_RESUME: "GAME_RESUME",
    GAME_OVER: "GAME_OVER",
    GAME_WON: "GAME_WON",
    LEVEL_LOADED: "LEVEL_LOADED",
    ROOM_CLEARED: "ROOM_CLEARED",
    ENEMY_SPAWNED: "ENEMY_SPAWNED",
    ENEMY_DIED: "ENEMY_DIED",
    PLAYER_DAMAGED: "PLAYER_DAMAGED",
    PLAYER_HEALED: "PLAYER_HEALED",
    BONUS_COLLECTED: "BONUS_COLLECTED",
    AI_ADAPTATION: "AI_ADAPTATION"
};
